import * as _ from 'lodash';
import { Component, Input, OnInit } from '@angular/core';
import { TrackerService } from '../../../services/tracker.service';
import { StateService } from '@uirouter/angular';
import { ModalComponent } from '../../../../../core/config/core.modal-helpers';

@Component({
  selector: 'tracker-admin-workflow-transition-modal',
  template: require('./tracker.workflow.transition.modal.component.html'),
})
export class TrackerAdminWorkflowTransitionModalComponent extends ModalComponent implements OnInit {
  @Input() workflowField: any;
  @Input() fromFieldElement: any;
  @Input() toFieldElement: any;
  @Input() tracker: any;
  @Input() roles: any;
  @Input() extraFields: any;
  @Input() selectFields: any;

  activeWorkflowTab: string;

  /**
   * Constructor for the TrackerAdminWorkflowTransitionModalComponent
   * @param trackerService - Service to handle tracker-related operations
   * @param stateService - Service to handle state transitions
   */
  constructor(
    private trackerService: TrackerService,
    private stateService: StateService
  ) {
    super();
  }

  /**
   * Angular lifecycle hook that initializes the component
   */
  ngOnInit() {
    this.activeWorkflowTab = 'tab-workflow-main';
  }

  /**
   * Saves the current workflow transition
   * @param isEnabled - Indicates whether the transition is enabled
   */
  save(isEnabled: boolean) {
    this.toFieldElement.isEnabled = isEnabled;
    this.trackerService.workflow.save(this.tracker.id, this.workflowField).then(() => {
        const currentTab = _.get(this.stateService, 'params.tab', 'tab-workflow');
        this.stateService.go('.', { workflowField: this.workflowField.alias, tab: currentTab }, { reload: true, inherit: true, notify: true });
    });
    this.closeModal();
  }

  /**
   * Cancels the workflow transition and closes the modal
   */
  cancel() {
    this.closeModal();
  }

  /**
   * Sets the extra field for the transition
   * @param field - The extra field to set
   */
  setChangeExtraField(field: any) {
    this.toFieldElement.changeExtraField = _.cloneDeep(field);
  }
}
